import { SharedFileRequest } from "@wingspanhq/wingspan-api-sdk";

import {
  ContextItem,
  RequirementContextType,
  RequirementTableItemData
} from "../../../../types";

import { getSharedFileRequirementStatus } from "./getSharedFileRequirementStatus";

export const getSharedFilePayerRequirementStatus = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem,
  sharedFileRequest: SharedFileRequest | undefined
) => {
  return getSharedFileRequirementStatus(
    requirement,
    contextItem,
    sharedFileRequest,
    RequirementContextType.Payee
  );
};
